export default {
  'practice-in-seeing': {
    'course-title': 'Introductions - Reading to Get the Rhythm',
    'course-name': '4A - Lecture',
    'course-video': {
      'title': 'Section 4 BUILDING A PYRAMID<br/>1’15:53 – 1’24:36 4A STRUCTURE OF THE INTRODUCTION. EX 4 intro A <br/> developing the introduction + 4A reading to get the rhythm +4B-2 more<br/> practice in finding SCQ',
      'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
      'lecture-title': '4A Lecture'
    },
    'unit-section-title': '4A Exercises',
    'exercise-intro': `
    <p>You now know that an introduction is meant to remind the reader of what he already knows about the subject of your document, prompting the question to which you wish to give the answer. And you will present that information in story form:</p>
    <br/>
    <ul>
        <li>Situation (with which he is familiar), within which a</li>
        <li>Complication developed (with which he is also familiar), that then triggered the</li>
        <li>Question, to which your document is the answer</li>
    </ul>
    <br/>
    <br/>
    <p>In beginning to write, your tendency will be to spend time on the wording of your story, which can be time consuming and frequently leads in the wrong direction. To speed the process, try first to get the basic pattern of your story clear in your mind. In general, stories follow three basic patterns, leading to three relatively standard questions:</p>
    <br/>
    <div class="desc-table">
      <div>
        <p class="desc-table__title">WHAT SHOULD WE DO?</p>
        <br/>
        <p>Want to do X</p>
        <p>Have problem</p>
        <p>What do?</p>
      </div>
      <div>
        <p class="desc-table__title">HOW SHOULD WE DO IT?</p>
        <br/>
        <p>Want to achieve X</p>
        <p>Requires Y action</p>
        <p>How do?</p>
      </div>
      <div>
        <p class="desc-table__title">SHOULD WE DO IT?</p>
        <br/>
        <p>Want to do X</p>
        <p>Will cause problem</p>
        <p>Should we do it?</p>
      </div>
    </div>
    <br/>
    <br/>
    <p>Knowing the kind of question your story is meant to raise in the reader’s mind makes it easier for you to structure the story itself.</p>
    <br/>
    <br/>
    <p>The next set of exercises is meant to help you recognize and reflect the basic patterns of introductory stories. In each case, I have stated the SCQs for you as they appear in the text. Your job is to look behind the words to the essence of what is being said, and fill in the parts of the basic story pattern it reflects, substituting Xs and Ys, etc. for specific nouns.</p>
    <br/>
    <br/>
    <p>Then press Basic Structure to see if your answer matches mine.</p>
    `,
    'menu-list': {
      'exercise-1': 'Black Holes',
      'exercise-2': 'Entrepreneurs',
      'exercise-3': 'The Optimal Office',
      'exercise-4': 'Alpha’s Ability to Control Costs',
      'exercise-5': 'The Role of the Board'
    },
    'exercise-1': {
      'number': '4A - Exercise 1',
      'title': 'Black Holes',
      'description': `One day the sun will fail. The fuel powering its nuclear fusion will run out, the sky will grow cold and, if Earth survives at all, humankind will be plunged into perpetual winter.<br/>
<br/>To stay alive, our descendants will need to make alternative arrangements. They will first exhaust the resources of Earth, then the solar system, and eventually all the stars in all the galaxies in the visible universe. With nothing left to burn they will surely cast their gaze on the only remaining store of energy: black holes. Might they be able to harvest this energy and save civilization?`,
      'reference': `Can We Mine a Black Hole?<br/>
by Adam Brown, Scientific American, February 2015.<br/><br/><br/><br/>`,
    },
    'exercise-2': {
      'number': '4A - Exercise 2',
      'title': 'Entrepreneurs',
      'description': `Two common notions shape our views about entrepreneurs, and neither is quite right. One of them imagines that they craft careful business plans and execute them skillfully. In fact, most new businesses don’t adhere to a script. They adapt and modify as they go along, learning from feedback and trying new things.<br/><br/>
The other sees entrepreneurs as slightly wacky, possessed by extraordinary self-belief and willing to take a bet with very long odds. They exhibit common cognitive biases that are often associated with bad decisions, but are useful when it comes to starting a new business. This view, currently in vogue, isn’t right either.<br/><br/>
The truth is less surprising but no less impressive. Successful entrepreneurs display a blend of seemingly contradictory skills. They combine careful analytical thinking – what we associate with the left brain – and a willingness to push boundaries – what we call the right stuff.`,
      'reference': `Phil Rosenzweig writing in Wired, “Ideas Bank”, January 2014`,
    },
    'exercise-3': {
      'number': '4A - Exercise 3',
      'title': 'The Optimal Office',
      'description': `Though the “open plan” modern office, with its sea of desks, might look like the offspring of a newsroom or a trading floor, it can trace its heritage to 1960s Germany. There, two brothers who worked in their father’s office-furniture business kicked off the Bürolandschaft, or “office landscape” movement, which sought to boost communication and efficiency and de-emphasize status.<br/><br/>
As the idea took hold in North America in the decades that followed, employers switched from traditional offices with one or two people per room to large, wall-less spaces. By the turn of the century, roughly two-thirds of U.S. workers spent their days in open-plan offices.<br/><br/>
But as the layout became commonplace, problems emerged. A 2002 longitudinal study of Canadian oil-and-gas company employees who moved from a traditional office to an open one found that on every aspect measured, from feelings about the work environment to co-worker relationships to self-reported performance, employees were significantly less satisfied in the open office.`,
    },
    'exercise-4': {
      'number': '4A - Exercise 4',
      'title': 'Alpha’s Ability to Control Costs',
      'description': `Increased oil prices due to the recent developments in the Middle East have brought about the likelihood of reduced earnings for Alpha. In an effort to mitigate the earnings decline, Alpha has indicated that it plans to reduce operating cost (versus its original forecast) by $10 billion during the current fiscal year. Since raw material and variable operating costs are not very controllable over the short term, and will most likely increase on higher oil prices, the cost reductions will have to come from the fixed cost area.`,
    },
    'exercise-5': {
      'number': '4A - Exercise 5',
      'title': 'The Role of the Board',
      'description': `The new organization installed in October places full authority and responsibility for running the day-to-day activities of the two divisions squarely on the shoulders of the managers of those divisions. This move frees the Board to deal entirely with the broad matters of policy and planning that are its exclusive responsibility. However, the Board has for so long oriented itself to dealing with short-term operating problems that it is not presently in a position to focus its attention effectively on long range strategy development. Consequently, it must consider the changes needed to permit itself to do so.
      <br/><br/>Specifically, we believe it should:
      <ul>
        <li>Relinquish responsibility for day-to-day operating matters to the Executive Committee</li>
        <li>Broaden the composition to include outside members</li>
        <li>Establish policies and procedures to formalize internal operation</li>
      </ul>`,
    },
    'exercise-5-title': 'Monetary Policy',
    'congratulation-message': 'WELL DONE',
    'finish-section': 'You have completed Section 4A',
    'final-description': 'You recognize the rhythm of a good introduction',
    'next-course-button': 'proceed to 4B-1',
    'dashboard-button': 'Main menu',
  }
}




// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4a/practiceInSeeing/i18n/en.js